import React from 'react'
import Footer from '../components/Footer/Footer'
import './pagestyles/Biography.css'

function Biography() {
  return (
    <div> 
        <div className='bioBox textStyle'>
            <h1>
                Kushim bio
            </h1>
            <p>
                  I’m an independent artist, producer, and sound engineer, dedicated to creating "Spirit Led Music." <br/><br/>
                  My name, meaning "peace," perfectly reflects the tranquility woven into my sound and message.<br/>
                  Originally from Nigeria and now based in Namibia, my art is crafted with a clear purpose: to introduce listeners to the Prince of Peace, Jesus Christ (Isaiah 9:6). <br/>
                  Every record I produce is guided by the Holy Spirit, aiming for spiritual upliftment and edification.<br/><br/>Welcome to the "Peace Tribe" 🌿🌖🧡
            </p>
        </div>
        <Footer/>
    </div>
  )
}

export default Biography